// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2C5_9","footer":"ModalInfo_footer__37lmy"};